module.exports = __webpack_public_path__ + "img/微信图片_20240906111436.c5dca0df.jpg";